import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/app/[locale]/error.tsx");
